export const SET_TEMPLATES = 'CARTA_PAX/SET_TEMPLATES'
export const SET_TEMPLATE = 'CARTA_PAX/SET_TEMPLATE'
export const SET_BLOCKS = 'CARTA_PAX/SET_BLOCKS'
export const ADD_BLOCK = 'CARTA_PAX/ADD_BLOCK'
export const UPDATE_BLOCK = 'CARTA_PAX/UPDATE_BLOCK'
export const REMOVE_BLOCK = 'CARTA_PAX/REMOVE_BLOCK'
export const SET_SELECTED_BLOCK = 'CARTA_PAX/SET_SELECTED_BLOCK'
export const SET_LOADING = 'CARTA_PAX/SET_LOADING'
export const SET_SAVING = 'CARTA_PAX/SET_SAVING'
export const SET_DIRTY = 'CARTA_PAX/SET_DIRTY'
export const SET_REFERENCE_DATA = 'CARTA_PAX/SET_REFERENCE_DATA'
